import * as yup from "yup";
import {UserRole, wordsLimit} from "./consts";
import dayjs from "dayjs";
import useCommonQuery from "../hooks/trainingHooks/useCommonQuery";

const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
// const urlRegExp = /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/

export const getTrainingSchema = (dateRange)=> {
  return yup.object().shape({
    trainingType: yup.mixed()
        .oneOf(['LiveTraining', 'Webinar'],
        'Training Type must be one of the following values: LiveTraining, Webinar')
        .required('Training Type is a required field'),
    trainingName: yup.string()
        .min(1, 'Training Name must be at least 1 characters')
        .max(wordsLimit)
        .required('Training Name is a required field'),
    startDate: yup.date()
        .max(new Date(), 'Max Completion Date cannot pass today')
        .required('Completion Date is a required field'),
    /*endDate: yup.date()
        .min(yup.ref('startDate'), 'End Date must be no earlier than the Start Date')
        .max(new Date(), 'Max End Date cannot pass today')
        .required('End Date is a required field'),*/
    trainingHours: yup
        .number('Training Hours must be a positive integer')
        .min(1)
        .positive('Training Hours must be positive')
        .integer('Training Hours must be an integer')
        .required('Training Hours is a required field'),
   /* trainingUrl: yup.string().trim()
        .when('trainingType', ([trainingType], schema) => {
          return trainingType === 'Webinar' ?
              schema.required('Training URL is required for Webinar')
                  // .matches(urlRegExp, 'Please enter a valid url')
                  .min(0).max(wordsLimit)
            : schema.notRequired()
        }) */

  })
}

export const traineeSchema = yup.object().shape({
  traineeEmail: yup.string()
      .matches(emailRegExp, 'Trainee Email must be a valid email'),
  traineeFirstName: yup.string()
      .required('Trainee Firstname is a required field') ,
  traineeLastName: yup.string()
      .required('Trainee Lastname is a required field') ,
})


export const trainingNameSchema = yup.object().shape({
    trainingType: yup.mixed()
        .oneOf(['LiveTraining', 'Webinar'],
        'Training Type must be one of the following values: LiveTraining, Webinar')
        .required('Training Type is a required field'),
    trainingName: yup.string()
        .min(1, 'Training Name must be at least 1 characters')
        .max(wordsLimit)
        .required('Training Name is a required field'),
    fiscalYear: yup.date()
      .required('Fiscal Year is a required field'),
  })


export const userSchema = yup.object().shape({
  newUserEmail: yup.string().trim().email()
      .required("User Email is a required field"),
  firstName: yup.string().min(1)
      .required("User First Name is a required field"),
  lastName: yup.string().min(1)
      .required("User Last Name is a required field"),
  userRoleId: yup.string().required('User role is required'),
  servicerId: yup.string().required('Servicer is required'),
})

export const servicerSchema = yup.object().shape({
  servicerId: yup.string().trim().length(5).required('Servicer ID is required'),
  servicerName: yup.string().trim().min(1).required('Servicer name is required'),
  servicerTrsiiOptIn: yup.string().oneOf(['true', 'false']),
  servicerOptOutFlag: yup.string().oneOf(['true', 'false']),
})

export const approveTrainingSchema = (dateRange)=> {
  return yup.object().shape({
    trainingType: yup.mixed()
        .oneOf(['LiveTraining', 'Webinar'],
            'Training Type must be one of the following values: LiveTraining, Webinar')
        .required('Training Type is a required field'),
    trainingName: yup.string()
        .min(1, 'Training Name must be at least 1 characters')
        .max(wordsLimit)
        .required('Training Name is a required field'),
    stdtrainingName: yup.string()
        .min(1, 'Training Name must be at least 1 characters')
        .max(wordsLimit)
        .required('Training Name is a required field'),
  })
}

  export const rejectTrainingSchema = ()=> {
    return yup.object().shape({
      note: yup.string()
          .min(1, 'note must be at least 1 characters')
          .max(wordsLimit)
          .required('note is a required field'),
    })
}